import { useEffect, useState } from 'react';
import { useNav } from '@/lib/nav';
import routes from '@/lib/routes';
import { authorizedFetch } from '@/lib/queryClient';
import { Check } from 'lucide-react';

export default function BillingSuccess() {
  const { go } = useNav();
  const [showBanner, setShowBanner] = useState(true);
  
  // Get URL params once for use in both useEffect and render
  const url = typeof window !== 'undefined' ? new URL(window.location.href) : null;
  const sessionId = url?.searchParams.get('session_id') || null;
  const fromPortal = url?.searchParams.get('from') === 'portal';

  useEffect(() => {
    if (!url) return;
    
    // Call confirm endpoint as a fallback when webhooks are delayed (only for checkout sessions)
    (async () => {
      try {
        if (sessionId) {
          await authorizedFetch('/api/billing/confirm', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: sessionId })
          });
        }
        // If coming from portal, sync billing data
        if (fromPortal) {
          try {
            await authorizedFetch('/api/billing/sync', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' }
            });
          } catch {}
        }
      } catch {}
      // Show banner for 2.5 seconds before redirecting
      const t = setTimeout(() => {
        setShowBanner(false);
        go(`${routes.dashboard()}?billing=success`);
      }, 2500);
      return () => clearTimeout(t);
    })();
  }, [go]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      {/* Success Banner */}
      {showBanner && (
        <div className="fixed inset-x-0 top-0 z-50 animate-in fade-in slide-in-from-top-2 duration-300">
          <div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
            <div className="mt-4 rounded-lg bg-green-600 border border-green-700 shadow-lg">
              <div className="flex items-center gap-3 px-4 py-3">
                <div className="flex-shrink-0">
                  <Check className="h-5 w-5 text-white" strokeWidth={2.5} />
                </div>
                <p className="text-sm font-medium text-white">
                  {fromPortal ? 'Plan updated successfully!' : "You're now subscribed! Your plan is being updated..."}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="text-center space-y-3 px-4">
        <div className="flex justify-center mb-4">
          <div className="rounded-full bg-green-100 dark:bg-green-900/30 p-3">
            <Check className="h-8 w-8 text-green-600 dark:text-green-400" strokeWidth={2.5} />
          </div>
        </div>
        <h1 className="text-2xl font-semibold">{fromPortal ? 'Plan updated successfully' : 'Payment successful'}</h1>
        <p className="text-muted-foreground">Redirecting to your dashboard...</p>
      </div>
    </div>
  );
}


